import { render } from "./DetailedKeyPerformanceView.vue?vue&type=template&id=10c11315"
import script from "./DetailedKeyPerformanceView.vue?vue&type=script&lang=js"
export * from "./DetailedKeyPerformanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__